var map = {
	"./1.png": 4015,
	"./10.png": 2543,
	"./11.png": 3526,
	"./12.png": 4733,
	"./13.png": 8052,
	"./2.png": 452,
	"./3.png": 2957,
	"./4.png": 1394,
	"./5.png": 395,
	"./6.png": 5360,
	"./7.png": 6537,
	"./8.png": 1294,
	"./9.png": 8983
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3807;